import { format, parseISO } from 'date-fns';

export const dateToCustomFormat = (date: Date, formatString: string): string => {
  return format(date, formatString);
};

export const dateToLocalIsoString = (date: Date = new Date()): string => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
};

export const dateToUTCString = (date: Date = new Date()): string => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.000'Z'");
};

export const formatDateToString = (
  date: Date,
  { onlyDate = false, onlyTime = false }: { onlyDate?: boolean; onlyTime?: boolean } = {},
): string => {
  const dateValue = dateToCustomFormat(date, 'dd-MM-yyyy');
  const timeValue = dateToCustomFormat(date, 'HH:mm');
  if (onlyDate) return dateValue;
  if (onlyTime) return timeValue;
  return `${dateValue} a las ${timeValue}`;
};

export const formatTimestamp = (
  timestamp: string,
  {
    onlyDate = false,
    onlyTime = false,
    UTCSensitive = false,
  }: { onlyDate?: boolean; onlyTime?: boolean; UTCSensitive?: boolean } = {},
): string => {
  const sanitizedTimestamp = UTCSensitive ? timestamp : timestamp.replace('Z', '');
  return formatDateToString(new Date(sanitizedTimestamp), { onlyDate, onlyTime });
};

export const stringToDate = (
  dateStringIso: string,
  { defaultUTC = false }: { defaultUTC?: boolean } = {},
): Date => {
  const isoDatePattern = /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})(\.\d+)?([+-]\d{2}:?\d{2}|Z)$/;
  const hasOffset = isoDatePattern.test(dateStringIso);
  const dateString = hasOffset ? dateStringIso : `${dateStringIso}+00:00`;
  const date = defaultUTC ? new Date(dateStringIso) : parseISO(dateString);
  return date;
};
